
import { defineComponent } from "vue";
import { ISystemTemplatesModel } from "@/interfaces/modules";

import TemplatesService from "@/api/Template/TemplatesService";
import router from "@/router";

export default defineComponent({
  name: "App",
  data() {
    return {
      form: {
        loading: true,
        dialog: false,
        valid: false,
        record: {} as ISystemTemplatesModel,
        rules: {
          required: [(v: any) => !!v || "Este campo es requerido"],
        },
      },
      table: {
        filters: {
          search: "",
        },
        currentPage: 1,
        loading: false,
        headers: [
          {
            key: "Code",
            label: "Código",
            sortable: true,
          },
          {
            key: "Name",
            label: "Nombre",
            sortable: true,
          },
          {
            key: "Version",
            label: "Versión",
            sortable: true,
          },
          {
            key: "CreatedByFormat",
            label: "Creación",
            sortable: true,
          },
          {
            key: "ModifiedByFormat",
            label: "Ultima modificación",
            sortable: true,
          },
          {
            key: "action",
            label: "Acciones",
            sortable: false,
          },
        ],
        records: [],
        rowsPerPage: 10,
      } as any,
    };
  },
  computed: {
    filteredItems(): any {
      return this.table.filters.search
        ? this.table.records.filter((item: any) =>
            item.Name.toLowerCase().includes(
              this.table.filters.search.toLowerCase()
            )
          )
        : this.table.records;
    },
    formRecord(): any {
      return this.$refs.formRecord;
    },
    rows(): any {
      return this.table.records?.length || 0;
    },
  },

  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.table.loading = true;
      this.table.records = await TemplatesService.GetTemplates();
      this.table.loading = false;
    },
    templateEdit(Id: any) {
      router.push(`templates/edit/${Id}`);
    }
  },
});
